import React, { useState, useEffect } from 'react';
import DatenschutzModal from './DatenschutzModal';
import { useUser } from '../UserContext';

const CookieBanner = () => {
  const { user: currentUser } = useUser();
  const [showBanner, setShowBanner] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  useEffect(() => {
    // Prüfe ob bereits akzeptiert (mit E-Mail-Adresse)
    const userEmail = currentUser?.email;
    if (!userEmail) return;

    const privacyAccepted = localStorage.getItem(`privacyAccepted_${userEmail}`);
    const bannerDismissed = localStorage.getItem('cookieBannerDismissed');
    
    if (!privacyAccepted && !bannerDismissed) {
      setShowBanner(true);
    }
  }, [currentUser]);

  const handleAccept = () => {
    if (currentUser?.email) {
      localStorage.setItem(`privacyAccepted_${currentUser.email}`, new Date().toISOString());
    }
    localStorage.setItem('cookieBannerDismissed', 'true');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieBannerDismissed', 'true');
    setShowBanner(false);
    // Hier könnten Sie Analytics deaktivieren
  };

  const handleShowPrivacy = () => {
    setShowPrivacyModal(true);
  };

  if (!showBanner) return null;

  return (
    <>
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '10px 20px',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: '1200px',
          width: '100%',
          backgroundColor: '#2E7D32',
          color: 'white',
          padding: '15px 20px',
          borderRadius: '8px',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, minWidth: '300px' }}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>🍪 Cookies & Datenschutz</h4>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.4' }}>
              Wir verwenden Cookies und verarbeiten personenbezogene Daten für die Dienstplanung. 
              Durch die Nutzung stimmen Sie unserer{' '}
              <button
                onClick={handleShowPrivacy}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#FFD54F',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Datenschutzerklärung
              </button>{' '}
              zu.
            </p>
          </div>
          
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button
              onClick={handleDecline}
              style={{
                padding: '8px 16px',
                border: '1px solid #fff',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Ablehnen
            </button>
            <button
              onClick={handleAccept}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#FFD54F',
                color: '#2E7D32',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              ✓ Akzeptieren
            </button>
          </div>
        </div>
      </div>

      <DatenschutzModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        showAcceptButton={true}
        onAccept={handleAccept}
      />
    </>
  );
};

export default CookieBanner;
